// extracted by mini-css-extract-plugin
export default {"CustomVideo":"ramREd8nsz1o0SMAHx9AVQ=="};